export enum ColumnId {
    USER_NAME = 'user_name',
    EVENT_DATE = 'event_date',
    EVALUATION_DATE = 'evaluation_date',
    SCORE = 'score',
    EVALUATION_NAME = 'evaluation_name',
    STATUS = 'status',
    SELECT = 'select',
}
